import type { FC } from "react";

import { AtHomeDeliveryAddresses, NonAtHomeBillingAddresses } from "./components";
import type { DeliveryAddressesProps } from "./DeliveryAddresses.types";

export const DeliveryAddresses: FC<DeliveryAddressesProps> = ({
  formFieldsConfig,
  selectedShippingMethodType,
  firstname,
  lastname,
  telephone,
  billingAddressCardRef,
  showBillingValidationError = false,
}) => {
  if (selectedShippingMethodType === "atHome") {
    return (
      <AtHomeDeliveryAddresses
        formFieldsConfig={formFieldsConfig}
        firstname={firstname}
        lastname={lastname}
        telephone={telephone}
        billingAddressCardRef={billingAddressCardRef}
        showBillingValidationError={showBillingValidationError}
      />
    );
  }

  return (
    <NonAtHomeBillingAddresses
      formFieldsConfig={formFieldsConfig}
      billingAddressCardRef={billingAddressCardRef}
      showBillingValidationError={showBillingValidationError}
    />
  );
};
